import { useQuery } from "@apollo/client";
import { CommunicationReportsQueryVariables } from "generated-graphql/graphql";
import { gql } from "generated-graphql";

export const COMMUNICATION_REPORTS_QUERY = gql(`
  query CommunicationReports($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    tierIIReports(search:$search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        tenantId
        facilityId
        reportingYear
        reportKind
        createdAt
        encampStatus
        facility {
          id
          name
          customerFacilityId
        }
      }
      count
    }
  }
`);

export function useCommunicationReports({
  tierIIReportIds,
  ...variables
}: { tierIIReportIds?: string[] } & CommunicationReportsQueryVariables) {
  return useQuery(COMMUNICATION_REPORTS_QUERY, {
    variables: {
      ...variables,
      search: tierIIReportIds && `id:${tierIIReportIds.join("|")}`,
    },
    skip: !tierIIReportIds?.length,
  });
}
